'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { HeaderLevel2 } from '@/app/components/headers/header-level-2';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { Image } from '@/app/components/media/image';
import { MixerItem } from '@/app/cv/components/sections/products/mixer/mixer-item';
import type { ProductMixerSectionProps } from '@/app/cv/components/sections/products/types';
import { useRevealAnim } from '@/app/hooks/useRevealAnim';
import backgroundColorStyles from '@/app/styles/colors/background-colors.module.css';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const ProductMixer = t0 => {
  const $ = _c(28);
  const {
    lead,
    title,
    description,
    image,
    items: t1,
    buttons: t2,
    testId: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const items = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const buttons = t5;
  const testId = t3 === undefined ? "product-mixer" : t3;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      defaultBaseDelay: 0.04
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  useRevealAnim(t6);
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn(backgroundColorStyles["bg-gradient-dark-grey"], "scroll-mt-14 xl:flex xl:gap-12");
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = `${testId}-section`;
  let t9;
  if ($[6] !== t8) {
    t9 = createDataAttributes({
      test: t8
    });
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== image || $[9] !== title) {
    t10 = !!image && <div className="aspect-1-1 relative xl:flex-1" {...createDataAttributes({
      test: "wrapper-image"
    })}><Image layout="ratio" aspectRatio="aspect-1-1" className="h-full" placeholder="dark-shimmer" src={image} alt={title || "mixer"} width={960} height={587} sources={[{
        srcset: image,
        media: {
          minWidth: 1920
        },
        options: {
          width: 1024,
          crop: "1:1"
        }
      }, {
        srcset: image,
        media: {
          minWidth: 1280,
          maxWidth: 1919
        },
        options: {
          width: 828,
          crop: "1:1"
        }
      }, {
        srcset: image,
        media: {
          minWidth: 1024,
          maxWidth: 1279
        },
        options: {
          width: 1280,
          crop: "3:2"
        }
      }]} srcSetOptions={{
        crop: "3:2"
      }} sizes="(min-width: 1280px) 50vw, 100vw" /></div>;
    $[8] = image;
    $[9] = title;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = createDataAttributes({
      test: "container"
    });
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== description || $[13] !== lead || $[14] !== title) {
    t12 = !!title && <HeaderLevel2 lead={lead} title={title} theme="dark" leadClassName="text-white" contentClassName="text-white" content2ClassName="text-white space-y-2" {...description && {
      content1: {
        content: description
      }
    }} />;
    $[12] = description;
    $[13] = lead;
    $[14] = title;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== items) {
    t13 = items.length > 0 && <div className="grid gap-y-6" data-revealanim={true} {...createDataAttributes({
      test: "items"
    })}>{items.map(_temp)}</div>;
    $[16] = items;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== buttons) {
    t14 = buttons.length > 0 && <ButtonGroup data-revealanim={true} {...createDataAttributes({
      test: "cta-buttons"
    })}>{buttons.map(_temp2)}</ButtonGroup>;
    $[18] = buttons;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14) {
    t15 = <Container size="none" className="px-4 py-10 xl:flex-1" data-revealanim={true} {...t11}><div className="grid gap-y-6">{t12}{t13}{t14}</div></Container>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t15 || $[26] !== t9) {
    t16 = <Section id="specialmodel" className={t7} size="none" data-revealanim-group={true} {...t9}>{t10}{t15}</Section>;
    $[24] = t10;
    $[25] = t15;
    $[26] = t9;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
};
function _temp(item, index) {
  return <MixerItem key={index} title={item.title || `item-${index}`} description={item.description} badge={item.badge} />;
}
function _temp2(button, index_0) {
  return <Button key={index_0} {...button} />;
}